import React from 'react';

import type { FeatureProps } from '../Feature';
import { Feature } from '../Feature';

import styles from './styles.module.scss';

export const FeatureList: React.FC<{
  items: FeatureProps[];
  onClick?: (id: number | string, title: string) => void;
}> = ({ items, onClick }) => {
  const list = items.map(item => (
    <div key={item.id} className={styles.child}>
      <div className={styles.item}>
        <Feature {...item} onClick={onClick} />
      </div>
      <div className={styles.split} />
    </div>
  ));

  return <div className={styles.container}>{list}</div>;
};
